<template>
  <div>
    <md-dialog :md-active="open" class="modalEdit modal-img-archive">
      <div class="w-100 position-fixed mobile-cancel">
        <span
          class="material-icons close text-right"
          @click="closeModal"
        >close</span
        >
      </div>
      <div class="body-modal-img-archive py-5 modal-body">
        <md-dialog-title class="md-title pb-3 add-category text-left">
          {{ item?.id ? 'EDITAR' : 'AGREGAR' }}
          <span v-if="typeFile === 'image'" class="text-uppercase">imagen</span>
          <span
            v-else-if="typeFile === 'file'"
            class="text-uppercase"
          >archivo</span
          >
          <span v-else class="text-uppercase">{{ typeFile }}</span>
        </md-dialog-title>

        <div class="dialog-body">
          <div class="row">
            <div class="form-group col-md-12 mb-2 pt-0">
              <h4 class="text-bold mb-3 float-left">NOMBRE</h4>
              <base-input
                v-model="media.title"
                name="name"
                placeholder="Titulo del archivo."
              ></base-input>
            </div>
            <div class="form-group col-md-12 mb-2">
              <h4 class="text-bold mb-3 float-left">DESCRIPCIÓN</h4>
              <textarea
                v-model="media.description"
                name="description"
                class="form-control"
                placeholder="Coloca la descripción."
                rows="3"
              ></textarea>
            </div>
            <div class="form-group col-md-12 mb-2 text-left">
              <h4 class="text-bold">
                <span
                  v-if="typeFile === 'image'"
                  class="text-uppercase"
                >imagen</span
                >
                <span
                  v-else-if="typeFile === 'file'"
                  class="text-uppercase"
                >archivo</span
                >
                <span v-else class="text-uppercase">{{ typeFile }}</span>
              </h4>
              <p class="text-muted">
                Los formatos permitidos son:
                <span v-if="typeFile" class="text-uppercase">{{
                    acceptedFiles[typeFile]
                  }}</span>
              </p>
              <div class="col-sm-12 px-0">
                <vue-dropzone
                  id="videoDropzone"
                  ref="videoDropzone"
                  :options="dropzoneOptions"
                  @vdropzone-success-multiple="completeUpload"
                  @vdropzone-file-added="fileAdded"
                ></vue-dropzone>
              </div>
            </div>
          </div>
        </div>

        <md-dialog-actions class="modal-footer">
          <md-button class="btn-primary w-auto" @click="closeModal">
            CANCELAR
          </md-button>
          <base-button
            :loading="isLoading"
            class="btn-primary ml-0 w-auto"
            @click="item?.id ? updateMediaFile() : createMediaFile()"
          >
            {{ item?.id ? 'EDITAR' : 'AGREGAR' }}
          </base-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import {
  MEDIA_CREATE_FILE,
  MEDIA_UPDATE_FILE,
} from '@/store/actions/media';
import axios from 'axios';
import { BUNNY_ACCESS_KEY_ID, BUNNY_CDN_URL, LIBRARY_BUNNY_ID } from '@/util/constants';
import { sha256 } from 'js-sha256';

let tus = require('tus-js-client');

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },

    typeFile: {
      type: String,
      default: 'file',
    },

    categorySelected: {
      type: Number || String,
      default: null,
    },
  },
  emits: [
    'close-modal',
    'success',
  ],
  data () {
    return {
      isLoading: false,
      fileToUpload: {
        filename: '',
        description: '',
      },
      media: {
        title: '',
        description: '',
        url: '',
      },
      acceptedFiles: {
        image: '.jpg, .jpeg, .png, .gif',
        video: '.mov, .mpeg4, .mp4, .m4v, .avi, .wmv, .mpegps, .flv',
        file: '.pdf, .doc, .docx, .ppt, .pptx, .xlsx, .xls, .txt',
      },
      file: null,
      dropzoneOptions: {
        url: `/no-upload-needed`,
        thumbnailWidth: 150,
        maxFilesize: 9999999,
        timeout: 9999999,
        addRemoveLinks: true,
        uploadMultiple: true,
        acceptedFiles: 'video/mp4,video/x-m4v,video/*',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('user-token'),
        },
        autoProcessQueue: false,
        maxFiles: 1,
      },
      processFile: 0,
      fileCount: 0,
    };
  },
  computed: {
    open: {
      get: function() {
        return this.isOpen;
      },
      set: function() {
        this.closeModal();
      },
    },
  },
  watch: {
    typeFile: function(val) {
      this.dropzoneOptions.acceptedFiles = this.acceptedFiles[val];
    },
    item: function(value) {
      if (value) {
        this.media = {
          id: value.id,
          title: value.title,
          description: value.description,
          url: value.url,
        };
      }
    },
  },
  methods: {
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    async createBunnyVideo (filename) {
      const url = `https://video.bunnycdn.com/library/${LIBRARY_BUNNY_ID}/videos`;
      const response = await axios.post(url,
        {
          title: filename,
          collectionId: '9e5a3917-e725-4ce6-a8e9-7e7bca796fbb',
        }, {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            AccessKey: BUNNY_ACCESS_KEY_ID,
          },
        });
      return response.data;
    },
    async createMediaFile () {

      let fileCreated = null;
      this.isLoading = true;
      if (this.file && ['image', 'file'].includes(this.typeFile)) {

        fileCreated = await this.createFileType(this.file);

      }

      if (this.file && this.typeFile === 'video') {

        return await this.createVideoType(this.file);
      }

      if (!fileCreated) {
        this.isLoading = false;
        return this.notify('error', 'Tenemos problemas para crear el archivo');
      }

      try {
        const data = {
          title: this.media.title,
          filename: this.file.name,
          description: this.media.description,
          size: this.file.size,
          extension: this.file.type,
          url: this.media.url,
          type: this.typeFile,
          file_url: `${BUNNY_CDN_URL}/media/${this.typeFile}/${this.file.name}`,

        };

        await this.$store
          .dispatch(MEDIA_CREATE_FILE, data);
        this.notify('success', 'Se ha creado el archivo correctamente');
      } catch {
        this.isLoading = false;
        return this.notify('error', 'Tenemos problemas para crear el archivo');

      }
      return this.closeModal();
    },
    async updateMediaFile () {
      let fileCreated = null;
      this.isLoading = true;
      if (this.file && ['image', 'file'].includes(this.typeFile)) {

        fileCreated = await this.createFileType(this.file);

      }

      if (this.file && this.typeFile === 'video') {

        return await this.createVideoType(this.file);
      }

      const data = {
        id: this.media.id,
        title: this.media.title,
        ...this.file && {
          filename: this.file.name,
          size: this.file.size,
          extension: this.file.type,
        },
        description: this.media.description,
        url: this.media.url,
        ...fileCreated && {
          file_url: `${BUNNY_CDN_URL}/media/${this.typeFile}/${this.file.name}`,
        },
      };
      try {
        await this.$store
          .dispatch(MEDIA_UPDATE_FILE, data);
        this.notify('success', 'Se ha actualizado el archivo correctamente');

      } catch {
        this.isLoading = false;
        return this.notify('error', 'Tenemos problemas para actualizar el archivo');

      }

      if (this.typeFile !== 'video') {
        return this.closeModal();
      }

      return null;

    },
    closeModal () {
      this.$emit('close-modal', 'mediaFiles');
      this.$emit('success');
      this.media = {
        title: '',
        description: '',
        url: '',
        file: null,
      };
      this.file = null;
      this.isLoading = false;
    },

    getQueuedFile (fileId = null) {
      const dropzoneInstance = this.$refs.videoDropzone.dropzone;
      if (!dropzoneInstance) return null;

      const queuedFiles = dropzoneInstance.getQueuedFiles();
      if (fileId) {
        return queuedFiles.find(file => file.upload.uuid === fileId);
      }
      return queuedFiles.length > 0 ? queuedFiles[0] : null;
    },
    updateProgressFile (fileId, progress) {
      const fileToUpdate = this.getQueuedFile(fileId);
      if (fileToUpdate) {
        const dropzoneInstance = this.$refs.videoDropzone.dropzone;

        dropzoneInstance.emit('uploadprogress', fileToUpdate, progress);
      } else {
        console.warn(`No se encontró el archivo con ID ${fileId} en la cola.`);
      }
    },

    async createBunnyFile (file) {
      const vm = this;
      const fileId = file.upload.uuid || null;

      const storageZone = await axios.put(`https://ny.storage.bunnycdn.com/maquillate/media/${this.typeFile}/${file.name}`, file, {
        headers: {
          AccessKey: '55d97b04-48ac-4fde-837f4e4bd93b-b34a-40b7',
          'Content-Type': 'application/octet-stream',
        },
        onUploadProgress: (progressEvent) => {

          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          vm.updateProgressFile(fileId, progress);
        },
      });

      return storageZone.data;
    },

    async createVideoType (file) {
      const bunnyVideo = await this.createBunnyVideo(file.name);

      if (!bunnyVideo) {
        return null;
      }

      const vm = this;

      const videoGuid = bunnyVideo.guid;
      const presignedSignature = sha256(LIBRARY_BUNNY_ID + BUNNY_ACCESS_KEY_ID + 99999999999 + videoGuid);
      const fileId = file.upload.uuid || null;

      const upload = new tus.Upload(file, {
        endpoint: 'https://video.bunnycdn.com/tusupload',
        retryDelays: [0, 3000, 5000, 10000, 20000],
        headers: {
          AuthorizationSignature: presignedSignature, // SHA256 signature (library_id + api_key + expiration_time + video_id)
          AuthorizationExpire: 99999999999, // Expiration time as in the signature,
          VideoId: videoGuid, // The guid of a previously created video object through the Create Video API call
          LibraryId: LIBRARY_BUNNY_ID,
        },
        metadata: {
          filetype: file.type,
          title: file.name,
        },
        onError: function() {
          vm.notify('error', `Tenemos problemas para carga el video: ${file.name}`);
        },
        onProgress: function(bytesUploaded, bytesTotal) {
          const progress = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
          vm.updateProgressFile(fileId, progress);

        },
        onSuccess: async function() {
          const data = {
            title: vm.media.title,
            filename: vm.file.name,
            description: vm.media.description,
            size: vm.file.size,
            extension: vm.file.type,
            url: vm.media.url,
            guid: bunnyVideo.guid,
            type: vm.typeFile,
            ...vm.item?.id && {
              id: vm.item.id,
            },
          };

          if (vm.item?.id) {
            await vm.$store
              .dispatch(MEDIA_UPDATE_FILE, data);
            this.notify('success', 'Se ha actualizado el video correctamente');

          } else {
            await vm.$store
              .dispatch(MEDIA_CREATE_FILE, data);
            this.notify('success', 'Se ha creado el video correctamente');

          }

          vm.closeModal();

        },
      });

      upload.start();

      return bunnyVideo;
    },

    async createFileType (file) {
      const bunnyFile = await this.createBunnyFile(file);

      if (bunnyFile && bunnyFile.HttpCode !== 201) {
        return null;
      }

      return bunnyFile;
    },
    async fileAdded (file) {
      this.file = file;
    },

    completeUpload (files) {
      this.processFile += Array.isArray(files) ? files.length : 0;
      if (this.processFile === this.fileCount) {
        this.$refs.videoDropzone.removeAllFiles();
      }
    },

  },
};
</script>
